import {MobileCard} from "./mobileCard";

export const initMobileSlideContent = () => {
    const overlays = document.querySelectorAll('.std-overlay-mobile');



    overlays.forEach(overlay => {
        new MobileCard(overlay);
    })
}